import { useState } from 'react';

import { Box, Button, Card, CardContent, Typography } from '@mui/material';

const STORAGE_KEY = 'GENERAL_OVERLAY_domain-change-notice-shown';

export default function GeneralInfoOverlay() {
  const [open, setOpen] = useState(() => localStorage.getItem(STORAGE_KEY) !== 'true');

  const handleDismiss = () => {
    localStorage.setItem(STORAGE_KEY, 'true');
    setOpen(false);
  };

  if (!open) {
    return null;
  }

  return (
    <Box
      sx={{
        position: 'absolute',
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        background: 'rgba(33, 58, 109, 0.75)',
        zIndex: 9000,
      }}
      display="flex"
      justifyContent="center"
      alignItems="center"
    >
      <Box maxWidth={700} sx={{ overflowY: 'auto', maxHeight: '99vh', mx: 1 }}>
        <Card>
          <CardContent>
            <Box textAlign="center">
              <Typography variant="h2">Our web address has changed!</Typography>
            </Box>
            <Box fontSize="2.4rem" textAlign="center">
              <p>
                Starting today Friday, April 3, Tertius is moving to{' '}
                <a href="https://tertius.dob.dc.gov/">tertius.dob.dc.gov</a>.
              </p>
              <p>
                If you visit the old address after April 3, you will be automatically redirected to this new one.
                However, please update any saved bookmarks or links.
              </p>
              <p>Your account, data, and login credentials are not affected by this change.</p>
              <p>
                Questions? Contact <a href="mailto:dob@dc.gov">dob@dc.gov</a>
              </p>
            </Box>
            <Box width="100%" display="flex" justifyContent="center">
              <Button variant="contained" color="primary" onClick={handleDismiss} disableElevation>
                Got it
              </Button>
            </Box>
          </CardContent>
        </Card>
      </Box>
    </Box>
  );
}
